/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartpictureshint4Inputs */

const en_eventaistartpictureshint4 = /** @type {(inputs: Eventaistartpictureshint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to three pictures, also with Ctrl+V or drag them here. The first becomes the cover, a flyer is read too.`)
};

const de_eventaistartpictureshint4 = /** @type {(inputs: Eventaistartpictureshint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu drei Bilder, auch mit Strg+V oder hierher ziehen. Das erste wird das Titelbild, ein Flyer wird mitgelesen.`)
};

/**
* | output |
* | --- |
* | "Up to three pictures, also with Ctrl+V or drag them here. The first becomes the cover, a flyer is read too." |
*
* @param {Eventaistartpictureshint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartpictureshint4 = /** @type {((inputs?: Eventaistartpictureshint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartpictureshint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartpictureshint4(inputs)
	return de_eventaistartpictureshint4(inputs)
});
export { eventaistartpictureshint4 as "eventAiStartPicturesHint" }